import {
  GET_ALL_CLIENTS_REQUEST,
  GET_ALL_CLIENTS_SUCCESS,
  GET_ALL_CLIENTS_FAIL,
  GET_CLIENT_BY_ID_REQUEST,
  GET_CLIENT_BY_ID_SUCCESS,
  GET_CLIENT_BY_ID_FAIL,
  ADD_CLIENT_REQUEST,
  ADD_CLIENT_SUCCESS,
  ADD_CLIENT_FAIL,
  UPDATE_CLIENT_STATUS_REQUEST,
  UPDATE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATUS_FAIL
} from "../constants/ClientConstants";

import ClientService from "../Services/clientservice";

export const GetAllClientsAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_CLIENTS_REQUEST });

    const { data } = await ClientService.GetAllClients();

    dispatch({
      type: GET_ALL_CLIENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_CLIENTS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const GetClientByIdAction = (clientId) => async (dispatch) => {
  try {
    dispatch({ type: GET_CLIENT_BY_ID_REQUEST });

    const { data } = await ClientService.GetClientById(clientId);

    dispatch({
      type: GET_CLIENT_BY_ID_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CLIENT_BY_ID_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const AddClientAction = (clientData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_CLIENT_REQUEST });

    const { data } = await ClientService.AddClient(clientData);

    dispatch({
      type: ADD_CLIENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADD_CLIENT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// NEW: Update Client Status Action
export const UpdateClientStatusAction = (clientId, status) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CLIENT_STATUS_REQUEST });

    const { data } = await ClientService.UpdateClientStatus(clientId, status);

    dispatch({
      type: UPDATE_CLIENT_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_CLIENT_STATUS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};